import React from 'react'

import Layout from '../Layout'

const Login = () => <Layout page="login">
	Login Page
</Layout>

export default Login